module.exports = {"header":"Online Chat","notSupportedBrowser":"We do not support Internet Explorer","input_placeholder":"Message...","header_title_first":"Online","header_title_second":"Chat","viewed":"Seen","connection_problem":"Connection problem","refresh_page":"Please refresh the page"}


//////////////////
// WEBPACK FOOTER
// ./src/components/locale/en.json
// module id = 244
// module chunks = 0